import PropTypes from 'prop-types'

import Pill from 'components/common/Pill'
import Text from 'components/common/Text'
import theme from 'theme'
import { pluralize } from 'utils/strings'

import { sortKubernetesObjectParams } from '../create/targets/kubernetes/kubernetes-target-utils'

export default function KubernetesTargets({ targets = [] }) {
  const formattedTargets = () => {
    let cluster = {}
    targets.forEach(({ kind, clusterId }) => {
      if (cluster[clusterId]) {
        if (cluster[clusterId][kind]) {
          cluster[clusterId][kind] += 1
        } else {
          cluster[clusterId][kind] = 1
        }
      } else {
        cluster = { ...cluster, [clusterId]: { [kind]: 1 } }
      }
    })

    return { cluster, clusterKeys: Object.keys(cluster) }
  }

  const { cluster, clusterKeys } = formattedTargets()
  const kindKeys = sortKubernetesObjectParams()

  return (
    <div>
      {clusterKeys.length
        ? clusterKeys.map((clusterId, clusterIndex) => {
            const keys = Object.keys(cluster[clusterId])

            return (
              <div key={`${clusterId}-${clusterIndex}`}>
                <Text
                  key={clusterId}
                  overflowEllipsis
                  as="small"
                  color="medium"
                  css={{
                    fontWeight: theme.fontWeights[1],
                    color: theme.colors.steel[1]
                  }}
                >
                  Cluster:{' '}
                  <span
                    css={{
                      fontWeight: theme.fontWeights[1],
                      color: theme.colors.steel[2]
                    }}
                  >
                    {clusterId}
                  </span>
                </Text>
                {kindKeys.displayed.map((kind, kindIndex) => {
                  if (!keys.includes(kind)) return null
                  return (
                    <Pill
                      key={`${clusterId}-${clusterIndex}-${kind}-${kindIndex}`}
                      css={{
                        marginLeft: theme.space[0],
                        textTransform: 'capitalize'
                      }}
                    >
                      {`${cluster[clusterId][kind]} ${pluralize(
                        kind.toLowerCase(),
                        cluster[clusterId][kind]
                      )}`}
                    </Pill>
                  )
                })}
              </div>
            )
          })
        : 'N/A'}
    </div>
  )
}

KubernetesTargets.propTypes = {
  targets: PropTypes.array
}
